import React, { useEffect, useState } from 'react';
import { CheckCircleIcon } from '@heroicons/react/24/solid';
import mixpanelService from '../services/mixpanelService';
import subscriptionService from '../services/subscriptionService';

function SubscriptionSuccess() {
  const [status, setStatus] = useState('syncing');

  useEffect(() => {
    mixpanelService.track('Checkout Returned');
    let cancelled = false;

    const confirmSubscription = async () => {
      for (let attempt = 0; attempt < 6 && !cancelled; attempt += 1) {
        try {
          const info = await subscriptionService.getSubscriptionInfo();
          if (info.status === 'active' || info.status === 'trialing') {
            setStatus('active');
            mixpanelService.track('Subscription Entitlement Confirmed');
            return;
          }
        } catch (error) {
          console.error('Subscription confirmation is still pending:', error);
        }
        await new Promise(resolve => setTimeout(resolve, 1500));
      }
      if (!cancelled) setStatus('pending');
    };

    confirmSubscription();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-100 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center">
        <CheckCircleIcon className="h-20 w-20 text-green-500 mx-auto mb-6" />
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          {status === 'active' ? 'Your subscription is ready' : 'Checkout complete'}
        </h1>
        <p className="text-lg text-gray-600 mb-6">
          {status === 'active'
            ? 'Stripe confirmed your subscription and premium access is enabled.'
            : status === 'syncing'
              ? 'We’re securely confirming your subscription with Stripe.'
              : 'Confirmation is taking longer than expected. You can review billing status from Subscription settings; you will not be shown as active until Stripe confirms it.'}
        </p>
        <button
          onClick={() => window.location.href = status === 'active' ? '/monitor' : '/subscription'}
          className="w-full py-3 px-6 bg-purple-600 text-white rounded-lg font-semibold hover:bg-purple-700 transition-colors"
        >
          {status === 'active' ? 'Go to Monitor' : 'View Subscription Status'}
        </button>
      </div>
    </div>
  );
}

export default SubscriptionSuccess;
